import { render, staticRenderFns } from "./OnlineExam.vue?vue&type=template&id=0358051b&scoped=true&"
import script from "./OnlineExam.vue?vue&type=script&lang=js&"
export * from "./OnlineExam.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/project-detail.css?vue&type=style&index=0&id=0358051b&scoped=true&lang=css&"
import style1 from "./OnlineExam.vue?vue&type=style&index=1&id=0358051b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0358051b",
  null
  
)

export default component.exports